export function removeEmptyParams(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != ''));
}
